import React, { useState, useEffect } from "react";
import TopCarousel from "../carousel/carousel";
import ScrollableCategory from "../scrollablecategory/scrollableCategory";
import Loader from "../Loader/loader";
import AllCategories from "../../data/category.json";
import AllGames from "../../data/gameData.json";
import { Helmet } from 'react-helmet-async';
import LineSeparator from "../bgMadness/line";

import LazyLoadCategory from "../scrollablecategory/LazyLoadCategory";
import { Button } from 'react-bootstrap';
import { useNavigate } from "react-router-dom";

const Home = () => {
  const [gamesCarousels, setGamesCarousels] = useState([]);
  const [hotGames, setHotGames] = useState([]);
  const [editorPicks, setEditorPicks] = useState([]);
  const [exclusiveGames, setExclusiveGames] = useState([]);
  const [bestGames, setBestGames] = useState([]);
  const [allGames, setAllGames] = useState([]);
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();
  const selectedCategory = (title) => {
    navigate(`/categories?c=${encodeURIComponent(title)}`);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setGamesCarousels(AllGames.hotgames);
        setHotGames(AllGames.hotgames);
        setEditorPicks(AllGames.editorpicks);
        setExclusiveGames(AllGames.exclusivegames);
        setBestGames(AllGames.bestgames);
        setAllGames(AllGames.data);
      } catch (error) {
        console.error("Failed to fetch data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  if (loading) {
    return <Loader />;
  }



  return (
    <div className="relative max-w-7xl mx-auto px-6 py-12 bg-[#0d0d1a] text-[#00F0FF] overflow-hidden  ">
      {/* Background Effects */}

      <div className="absolute inset-0 bg-gradient-to-b from-[#1a1a3e] via-[#12122b] to-[#0d0d1a] opacity-95"></div>
      <div className="absolute top-10 left-20 w-96 h-96 bg-[#00F0FF] opacity-30 rounded-full filter blur-[80px] animate-pulse"></div>
      <div className="absolute bottom-10 right-20 w-80 h-80 bg-[#FF007F] opacity-30 rounded-full filter blur-[80px] animate-flicker"></div>
      <div className="absolute top-1/3 left-1/4 w-48 h-48 bg-[#00FFA2] opacity-20 rounded-full filter blur-[60px] animate-glitch"></div>
      <div className="absolute bottom-20 left-1/3 w-40 h-40 bg-[#FFD700] opacity-15 rounded-full filter blur-[80px] animate-glitch"></div>

      <Helmet>
        <title>Play Free Browser Games Online | BrowserArena</title>
        <meta
          name="description"
          content="Discover the best free browser games to play instantly. No downloads, just pure online gaming fun at BrowserArena!"
        />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebSite",
            "name": "BrowserArena",
            "url": "https://browserarena.com",
            "potentialAction": {
              "@type": "SearchAction",
              "target": "https://browserarena.com/search?s={search_term_string}",
              "query-input": "required name=search_term_string"
            }
          })}
        </script>

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "BrowserArena",
            "url": "https://browserarena.com",
            "logo": "https://browserarena.com/logo.png", // use your actual logo path
            "sameAs": [
              "https://x.com/browserarena" // Update with actual social accounts
            ]
          })}
        </script>
      </Helmet>




      <div className="relative z-10 text-center">
        {/* <h1 className="text-5xl font-extrabold text-[#00F0FF] text-shadow-neon mb-8 animate-flicker">Cyber Arcade</h1> */}
        <div className="mt-1">
          {/* <TopCarousel carouselItems={gamesCarousels} /> */}
        </div>

        <div className="categories space-y-8 mt-12">
          <ScrollableCategory key={"Hot"} category={{ title: "🔥 Hot Games", id: 0 }} games={hotGames} className="border-glow animate-glitch" />
          <ScrollableCategory key={"Editor"} category={{ title: "🎯 Editor Picks", id: 0 }} games={editorPicks} className="border-glow flicker" />
          <ScrollableCategory key={"Exclusive"} category={{ title: "🚀 Exclusive Games", id: 0 }} games={exclusiveGames} className="border-glow-glitch" />
          <ScrollableCategory key={"Best"} category={{ title: "🏆 Best Games", id: 0 }} games={bestGames} className="border-glow animate-flicker" />

          {AllCategories.map((category, index) => {
            const gamesArray = allGames.filter(game => game.category === category.title);
            return gamesArray.length > 0 ? (
              <div className="min-h-[100px] animate-fadeIn duration-500" key={index}>
                <LazyLoadCategory>
                  <ScrollableCategory key={index} category={category} games={gamesArray} className="border-glow-random animate-glitch" />
                </LazyLoadCategory>
              </div>
            ) : null;
          })}
        </div>
      </div>
      <section className="mt-20 px-6 py-10 max-w-5xl mx-auto rounded-2xl border border-[#00F0FF] bg-[#111122]/80 shadow-lg shadow-[#00F0FF]/20 backdrop-blur-lg text-[#CCF6FF]">
        <div className="mt-14 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 max-w-5xl mx-auto">
          {AllCategories.map((cat, index) => (
            <button
              key={index}
              onClick={() => selectedCategory(cat.title)}
              className="text-sm font-medium px-4 py-2 rounded-lg bg-[#1a1a2e] text-[#00F0FF] border border-[#00F0FF]/60 hover:border-[#FF007F] hover:text-[#FF007F] transition duration-200 shadow-md hover:shadow-[#FF007F]/30"
            >
              {cat.title}
            </button>
          ))}
        </div>
      </section>
      <section className="mt-20 px-6 py-10 max-w-5xl mx-auto rounded-2xl border border-[#00F0FF] bg-[#111122]/80 shadow-lg shadow-[#00F0FF]/20 backdrop-blur-lg text-[#CCF6FF]">
        <h3 className="text-2xl sm:text-3xl font-semibold text-[#FF007F] mb-6 tracking-wide">Explore More</h3>
        <ul className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-base">
          <li>
            <a href="/about-browser-games" className="block hover:text-[#FF007F] hover:underline transition duration-150">
              🔍 What Are Browser Games?
            </a>
          </li>
          <li>
            <a href="/best-browser-games" className="block hover:text-[#FF007F] hover:underline transition duration-150">
              🏆 Best Browser Games 2025
            </a>
          </li>
          <li>
            <a href="/free-games" className="block hover:text-[#FF007F] hover:underline transition duration-150">
              🎮 Free Games – No Downloads
            </a>
          </li>
          <li>
            <a href="/html5-games" className="block hover:text-[#FF007F] hover:underline transition duration-150">
              ⚙️ Top HTML5 Games
            </a>
          </li>
        </ul>
      </section>
      <section className="mt-16 px-4 py-8 max-w-5xl mx-auto rounded-2xl border border-[#00F0FF] bg-[#111122]/80 shadow-lg shadow-[#00F0FF]/20 backdrop-blur-lg text-[#CCF6FF]">
        <h2 className="text-3xl sm:text-4xl font-extrabold text-[#00F0FF] mb-4 tracking-wide">
          Play Free Online Browser Games Instantly
        </h2>
        <p className="mb-3 leading-relaxed text-base sm:text-lg">
          Welcome to <span className="text-[#00FFA2] font-semibold">BrowserArena</span> – your go-to destination for the best
          <span className="text-[#FFD700] font-semibold"> free online games</span>. Explore a massive library of
          <span className="text-[#FF007F] font-semibold"> HTML5 browser games</span> — from puzzles and racing to multiplayer and stickman games.
        </p>
        <p className="mb-3 leading-relaxed text-base sm:text-lg">
          Whether you're using a mobile phone or desktop, enjoy <span className="text-[#00F0FF] font-semibold">no-download online play</span>,
          <span className="text-[#00FFA2] font-semibold"> instant casual gaming</span>, and fast-loading fun — no logins or installs needed.
        </p>
        <p className="mb-3 leading-relaxed text-base sm:text-lg">
          Discover new and trending titles every day. Our game collection is updated regularly, featuring everything from action-packed shooters and
          strategic tower defense to relaxing idle games and mind-bending puzzles. There's always something new to try on BrowserArena.
        </p>
        <p className="mb-3 leading-relaxed text-base sm:text-lg">
          All our games are playable directly in your web browser — optimized for both mobile and desktop devices. Whether you're killing time at work or
          diving into epic adventures on your phone, <span className="text-[#FFD700] font-semibold">BrowserArena delivers fun without friction</span>.
        </p>
        <p className="leading-relaxed text-base sm:text-lg">
          Join thousands of players who enjoy <span className="text-[#00F0FF] font-semibold">free online browser games</span> every day.
          Start playing now — no signup, no hassle. Just tap, play, and enjoy endless entertainment.
        </p>
      </section>



      <LineSeparator />



    </div>
  );
};

export default Home;
